import type {FunctionComponent} from 'react';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {LandingButtonLink} from '@app/components/landing-btn-link';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';
import {Image} from '@app/components/Image';
import {useAuthLink} from '@app/hooks/use-link';

export const Offer: FunctionComponent = () => {
	const {t} = useTranslation({ns: ['reviews', 'common']});
	const {getRegistrationLink} = useAuthLink();
	return (
		<LandingIllustrationSection
			imagePosition="right"
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'reviewslandingpage_title_wecarewhatyouthinkofus_standalone-web',
						)}
					</LandingHeading>
					<LandingParagraph>
						{t('reviewslandingpage_text_wecarewhatyouthinkofus_standalone-web')}
					</LandingParagraph>
					<LandingParagraph>
						{t(
							'reviewslandingpage_text_shareyourexperiencewithus_standalone-web',
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					sizes={{base: '100vw', md: '50vw'}}
					h={{base: '250px', md: '100%'}}
					src="fe1d9602056a1e6c809062b9df3f1c09.png"
					aspectRatio="2160/1740"
					alt={t(
						'reviewslandingpage_title_wecarewhatyouthinkofus_standalone-web',
					)}
				/>
			}
			cta={
				<LandingButtonLink
					href={getRegistrationLink()}
					tracking={{
						eventcategory: 'review',
						eventaction: 'signup',
						eventlabel: 'try-app',
					}}
				>
					{t('generic_action_discoverdeezer_standalone-web')}
				</LandingButtonLink>
			}
		/>
	);
};
